export class Controller {

    /** @ngInject */
    constructor($http) {
        this.$http=$http;
    }

    $onInit() {
        this.youtubeData();
    }

    youtubeData() {
        const url = `https://www.googleapis.com/youtube/v3/search?key=AIzaSyAcFtiyieqEPiLCSJh1Kt6fPRjCtksSalo&channelId=UC7rOgFOnh9aLx4wSsuAasDQ&part=snippet,id&order=date&maxResults=50`;
        return this.$http.get(url).then(({data}) => {
            this.youtubeJson=data;
            return data;
        });
    }

}



// WEBPACK FOOTER //
// ./src/portal/states/company/resources/resources.controller.js